import { render, staticRenderFns } from "./StockDelete.vue?vue&type=template&id=64012047"
import script from "./StockDelete.vue?vue&type=script&lang=js"
export * from "./StockDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports